import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShoppingList } from '../context/ShoppingListContext';
import './ShoppingList.css';

export default function ShoppingList({ defaultOpen = false, hideHeader = false }) {
  const { items, toggleItem, removeItem, addManual, clearChecked, uncheckedCount } = useShoppingList();
  const [open, setOpen] = useState(defaultOpen);
  const bodyVisible = hideHeader || open;
  const [inputVal, setInputVal] = useState('');
  const [copied, setCopied] = useState(false);

  const unchecked = items.filter(i => !i.checked);
  const checked   = items.filter(i => i.checked);

  const shareText = unchecked.length > 0
    ? `Einkaufsliste (Strixly):\n${unchecked.map(i => `• ${[i.amount, i.name].filter(Boolean).join(' ')}`).join('\n')}`
    : '';

  const hasNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  function handleAdd(e) {
    e.preventDefault();
    if (!inputVal.trim()) return;
    addManual(inputVal.trim());
    setInputVal('');
  }

  function handleWhatsApp() {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
  }

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  }

  return (
    <div className="shopping-widget">
      {!hideHeader && (
        <button className="shopping-widget-header" onClick={() => setOpen(o => !o)}>
          <span className="shopping-widget-title">🛒 Einkaufsliste</span>
          {uncheckedCount > 0 && (
            <span className="shopping-badge">{uncheckedCount}</span>
          )}
          <span className="shopping-chevron">{open ? '▲' : '▼'}</span>
        </button>
      )}

      {bodyVisible && (
        <div className={hideHeader ? 'shopping-widget-body shopping-widget-body--no-header' : 'shopping-widget-body'}>
          {items.length === 0 ? (
            <p className="shopping-empty">Noch leer — füge Zutaten aus Rezepten hinzu.</p>
          ) : (
            <ul className="shopping-list-ul">
              {unchecked.map(item => (
                <li key={item.id} className="shopping-item">
                  <button className="shopping-check" onClick={() => toggleItem(item.id)}>☐</button>
                  <span className="shopping-item-name">
                    {item.amount && <span className="shopping-item-amount">{item.amount} </span>}
                    {item.name}
                  </span>
                  <button className="shopping-remove" onClick={() => removeItem(item.id)}>✕</button>
                </li>
              ))}

              {checked.length > 0 && (
                <>
                  <li className="shopping-checked-label">Erledigt</li>
                  {checked.map(item => (
                    <li key={item.id} className="shopping-item shopping-item--checked">
                      <button className="shopping-check" onClick={() => toggleItem(item.id)}>☑</button>
                      <span className="shopping-item-name">{item.name}</span>
                      <button className="shopping-remove" onClick={() => removeItem(item.id)}>✕</button>
                    </li>
                  ))}
                  <li className="shopping-clear-row">
                    <button className="shopping-clear-btn" onClick={clearChecked}>Erledigte löschen</button>
                  </li>
                </>
              )}
            </ul>
          )}

          <form onSubmit={handleAdd} className="shopping-add-form">
            <input
              type="text"
              placeholder="Zutat hinzufügen…"
              value={inputVal}
              onChange={e => setInputVal(e.target.value)}
              className="shopping-add-input"
            />
            <button type="submit" className="shopping-add-btn">+</button>
          </form>

          {unchecked.length > 0 && (
            <div className="shopping-actions">
              {hasNativeShare && (
                <button className="shopping-action-btn" onClick={() => navigator.share({ text: shareText }).catch(() => {})}>
                  📤 Teilen
                </button>
              )}
              <button className="shopping-action-btn shopping-action-wa" onClick={handleWhatsApp}>
                💬 WhatsApp
              </button>
              <button className="shopping-action-btn" onClick={handleCopy}>
                {copied ? '✓ Kopiert' : '📋 Kopieren'}
              </button>
            </div>
          )}

          {hideHeader && (
            <div className="shopping-fulllink-row">
              <Link to="/einkaufsliste" className="shopping-fulllink">Vollansicht →</Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
